<template>
  <div class="m-0 dbozone-font bg-blsox" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blsox">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("1_3_base.paytable.title") }}
          </h5>
        </section>
      </div>

      <div class="mt-4 table-bg-blsox-high">
        <div
          class="table-detail"
          :class="`-blsox`"
          v-for="(text, index) in price.slice(4, 7)"
          :key="index"
        >
          <div class="text-price-box" :class="`-blsox ${index===0 ? 'mt-4' : index===1 ? 'mt-3' : 'mt-5'}`">
            <p class="payprice" :class="`-${lang} -blsox ${index===0 ? 'mt-5' : index===1 ? 'mt-5' : ''}`">
              {{ `x${text}` }}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-4 table-bg-blsox-low">
        <div
          class="table-detail"
          :class="`-blsox`"
          v-for="(text, index) in price.slice(7, 10)"
          :key="index"
        >
          <div class="text-price-box" :class="`-blsox ${index===0 ? 'mt-4' : index===1 ? 'mt-5' : 'mt-5'}`">
            <p class="payprice" :class="`-${lang} ${index===0 ? 'mt-5' : index===1 ? 'mt-4' : ''} -blsox`">
              {{ `x${text}` }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blsox mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("1_3_base.feature.title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("1_3_base.feature.blsox-1")
        }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img
          class="mt-5 mb-5 feature-blsox"
          :src="require(`../../assets/paytable/blsox/feature.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("1_3_base.feature.blsox-2")
        }}</span>
      </div>
    </div>

    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blsox mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("1_3_base.paytable.symtable_wild") }}
          </h5>
        </section>
      </div>
      <div class="justify-content-center d-flex flex-row">
        <img
          class="mt-5 mb-5 symbol-onerow"
          :src="require(`../../assets/paytable/blsox/any.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("blsox.text-rule13")
        }}</span>
      </div>
    </div>
    <div class="justify-content-center d-flex flex-row">
      <img
        class="mt-5 mb-5 symbol-onerow"
        :src="require(`../../assets/resultGame/blsox/symbol_5.png`)"
        alt=""
      />
    </div>

    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-blsox">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">
            {{ $t("1_3_base.winbetline") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-1 mb-1 mt-3">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("1_3_base.text-rule15")
        }}</span>
      </div>
      <div class="d-flex p-1 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("1_3_base.text-rule11")
        }}</span>
      </div>
      <div class="d-flex p-1 mb-1">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("1_3_base.text-rule12")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paytable-blsox",
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      paytable: this.data.config.payTable,
      price: {},
    };
  },
  created() {
    this.sortPrice();
  },

  methods: {
    sortPrice() {
      let priceList = [];
      for (let key in this.data.config.payTable) {
        priceList.push(this.data.config.payTable[key]);
      }
      let uniqe = priceList
        .filter((v, i, a) => a.indexOf(v) === i)
        .sort((a, b) => b - a);
      this.price = uniqe;
    },
  },
};
</script>

<style>
.nav-blsox {
  background-color: #0f6757;
  border-radius: 5px 5px 5px 5px;
}

.table-bg-blsox-low {
  background: url("~@/assets/paytable/blsox/pay_low.png") no-repeat;
  background-size: 100%;
  width: 100%;
  height: 100%;
  font-size: 40px;
}

.table-bg-blsox-high {
  background: url("~@/assets/paytable/blsox/pay_high.png") no-repeat;
  background-size: 100%;
  width: 100%;
  height: 100%;
  font-size: 40px;
}

.table-detail.-blsox {
  width: 100%;
  height: 166px;
}

.payprice.-zh {
  font-family: "dbozone", sans-serif;
}

.payprice.-blsox {
  font-size: 70px;
}

.bg-blsox {
  background: #002c23;
}

.feature-blsox {
  width: 120%;
}

.text-price-box.-blsox {
  right: -4px;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}
</style>